import React, { useEffect, useRef } from "react";
import Chart from "chart.js";

export default function CardBarChart({ title, data, labels, loading }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current && data && data.length > 0 && !loading) {
      const ctx = chartRef.current.getContext("2d");

      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      chartInstance.current = new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Participants",
              backgroundColor: "#38BDF8", // Bleu ciel professionnel
              borderColor: "#38BDF8",
              data: data,
              barThickness: 20,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: { display: false },
          scales: {
            xAxes: [
              {
                gridLines: { display: false },
                ticks: { fontColor: "#94A3B8" },
              },
            ],
            yAxes: [
              {
                gridLines: { color: "rgba(255, 255, 255, 0.1)" },
                ticks: { fontColor: "#94A3B8", beginAtZero: true },
              },
            ],
          },
        },
      });
    }
  }, [data, labels, loading]);

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-slate-800 w-full mb-6 shadow-xl rounded-2xl border border-slate-700">
      <div className="rounded-t mb-0 px-6 py-4 bg-transparent">
        <h2 className="text-white text-xl font-bold">{title}</h2>
      </div>
      <div className="p-6 flex-auto">
        <div className="relative h-[250px]">
          {loading ? (
            <div className="flex h-full items-center justify-center">
              <i className="fas fa-circle-notch animate-spin text-blue-500 text-3xl"></i>
            </div>
          ) : (
            <canvas ref={chartRef} />
          )}
        </div>
      </div>
    </div>
  );
}
